import { Typography, Space } from 'antd';
import { Title } from '../layouts/BasicProLayout/UserSelfDrawer/styled';

const { Text } = Typography;

const renderTitle = (title: string, type: SimpleListItemProps['type']) => {
    switch (type) {
        case 'default':
            return <Text>{title}</Text>;
        case 'large':
            return <Title>{title}</Title>;
        default:
            throw Error('Type not support');
    }
};

export type SimpleListItemProps = {
    key: string;
    label: string;
    title: string;
    type?: 'default' | 'large';
};

const SimpleListItem = ({ key, label, title, type = 'default' }: SimpleListItemProps) => (
    <Space key={key} direction="vertical">
        <Text type="secondary">{label}</Text>
        {renderTitle(title, type)}
    </Space>
);

export default SimpleListItem;
